import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { decodeProfileValues, getLocationBreadcrumbString } from '@pkgs/api/utils';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';
import { getPreferredProfileContent } from '@/components/property-expose/RichText/RichText';

const LocationText = dynamic(() => import('@/components/property-expose/LocationText/LocationText').then((mod) => mod.LocationText));

export const DynamicLocationText = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { genericListing },
  } = useListing();
  const profile = decodeProfileValues(genericListing.profile);
  const location = useMemo(() => getLocationBreadcrumbString({ listing: genericListing }), [genericListing]);
  const locationDescriptionContent = getPreferredProfileContent({
    richText: profile.locationDescriptionRich,
    text: profile.locationDescription,
    formatPlainText: (text) => <p>{text}</p>,
  });

  if (!locationDescriptionContent || !location || isUAExclusiveListingAndNotSignedIn) return null;

  return <LocationText locationDescriptionContent={locationDescriptionContent} location={location} />;
};
